import React, { useEffect, useState } from "react";
import { join, map, reduce } from "lodash";
import { Facet } from "@linkfluence/models/facet";
import Icon, { Glyph } from "@ui-kit/icon";
import SafeHTML from "@ui-kit/safe-html";
import TooltipHtml from "@ui-kit/tooltip/description";

interface IProps {
  labelizedFilters: {
    icon?: Glyph;
    id: Facet;
    label?: string;
    labels: { label: string }[];
  }[];
  tooltiped?: boolean;
  withFacetIcon?: boolean;
  facetsGlue?: string;
  facetsValuesGlue?: string;
}

const mergeLabels = (
  labels: { label: string }[],
  facetsValuesGlue: string
): string => join(map(labels, "label"), facetsValuesGlue);

const RadarlyFiltersRecap = ({
  labelizedFilters,
  tooltiped,
  withFacetIcon,
  facetsGlue = " ",
  facetsValuesGlue = " ",
}: IProps) => {
  const [facetsLabels, setFacetsLabels] = useState(null);
  const [tooltipContent, setTooltipContent] = useState(null);

  useEffect(() => {
    setFacetsLabels(
      map(labelizedFilters, ({ labels, icon, id }) => ({
        label: mergeLabels(labels, facetsValuesGlue),
        icon,
        id,
      }))
    );
  }, [labelizedFilters, facetsValuesGlue]);

  useEffect(
    () =>
      setTooltipContent(
        tooltiped
          ? reduce(
              labelizedFilters,
              (rest, filter, n) => {
                rest +=
                  (n ? ", " : "") +
                  (filter.label || filter.id) +
                  " : " +
                  mergeLabels(filter.labels, facetsValuesGlue);
                return rest;
              },
              ""
            )
          : null
      ),
    [labelizedFilters, tooltiped, facetsValuesGlue]
  );

  return (
    <TooltipHtml
      placement="bottom"
      content={tooltipContent}
      disabled={!tooltiped}
    >
      <span>
        {map(facetsLabels, ({ icon, label }, i) => (
          <span key={i}>
            {withFacetIcon && icon && <Icon glyph={icon} size={12} />}
            {withFacetIcon && icon && " "}
            <SafeHTML as="span" html={label} />
            {facetsGlue && +i !== facetsLabels.length - 1 && (
              <span>{facetsGlue}</span>
            )}
          </span>
        ))}
      </span>
    </TooltipHtml>
  );
};

export default RadarlyFiltersRecap;
